import './SelectOption.css'

function SelectOption({optionValue, optionText}) {
  return (
    <option
        value={optionValue}
    >{optionText}</option>
  )
}

export default SelectOption